<div
    [formGroup]="styleFormGroup"
    class="agpr-curatorStyleField"
>
    <div class="agpr-curatorStyleField-header">
        <label class="agpr-curatorStyleField-header-label">{{ 'PageBuilder.blockType.curation' | localize }}</label>
        <div class="agpr-formField-headingButtons agpr-curatorStyleField-header-button">
            @if(field.allowExpertMode) {
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-code"
                    tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                    tooltipPosition="top"
                    (click)="saveExpertTemplate()"
                ></agpr-button>
            }
            <agpr-button
                class="agpr-formField-headingButton"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-floppy-disk"
                tooltip="PageBuilder.formField.tooltip.saveStyle"
                tooltipPosition="top"
                (click)="saveStyle()"
            ></agpr-button>
        </div>
    </div>

    <div class="agpr-curatorStyleField-settings">
        <div class="agpr-inputGroupRow agpr-curatorStyleField-styleState">
            <div class="agpr-inputGroupRow-dropdown agpr-curatorStyleField-styleState-dropdown">
                <agpr-dropdown-field
                    formControlName="styleState"
                    [id]="'curatorStyleField_styleStateDropdown'"
                    [field]="styleStateField"
                    [labelClass]="'agpr-dropdown-label--semibold'"
                ></agpr-dropdown-field>
            </div>
            <div class="agpr-inputGroupRow-buttons agpr-curatorStyleField-styleState-button">
                <agpr-button
                    [id]="'curatorStyleField_styleStateButton'"
                    [style]="buttonTypes.block"
                    icon="fa-regular fa-duotone fa-gear"
                    tooltip="PageBuilder.formField.tooltip.manageStyles"
                    tooltipPosition="top"
                    (click)="manageStylesButtonClicked()"
                ></agpr-button>
            </div>
        </div>

        <div formGroupName="styles">
            <div class="agpr-curatorStyleField-row agpr-curatorStyleField-flex">
                <div class="agpr-curatorStyleField-colorPicker">
                    <agpr-color-picker-field
                        formControlName="backgroundColor"
                        class="agpr-curatorStyleField-backgroundColor"
                        [id]="'curatorStyleField_backgroundColor'"
                        [field]="colorPickerField"
                    ></agpr-color-picker-field>
                </div>
            </div>
            <agpr-block-padding
                formControlName="padding"
                [id]="'curatorStyleField_blockPadding'"
            ></agpr-block-padding>
        </div>
    </div>
</div>
